// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAr43JPUDDfld8oT9k0oKXdeKI-8ALcQxw",
    authDomain: "dhakaloan-a249a.firebaseapp.com",
    projectId: "dhakaloan-a249a",
    storageBucket: "dhakaloan-a249a.appspot.com",
    messagingSenderId: "265010395953",
    appId: "1:265010395953:web:e5b4fcb5ca2b1f3dd30e10",
    measurementId: "G-0EB3WWYZ2H"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
